import { createAction, props } from '@ngrx/store';

export const PROCESS_SET_OVERLAY = '[PROCESS][SET]::[Overlay]';

export const SetOverlay = createAction(
  PROCESS_SET_OVERLAY,
  props<{ overlay: boolean }>()
);
